export const productDetailsData = [
  {
    id: 1,
    name: "ULTRA Q",
    title: "Nd:Yag Q switch laser machine",
    tagline: "Professional Laser Treatment Technology",
    description: "The ULTRA Q represents the pinnacle of laser technology for professional skin treatments. With its super short pulse width and high output power, this advanced system delivers exceptional results for pigmentation removal, tattoo removal, and skin rejuvenation treatments.",
    mainImage: "/images/machines/1.png",
    hasResults: true,
    resultsHeading: "Clinical Results & Transformations",
    keyPoints: [
      "Super short pulse width (4 ns)",
      "Output Power: 3000 W",
      "Imported Heraeus Lamp from Germany",
      "Multiple laser modes available",
      "Real 8 mm Laser Rod"
    ],
    specifications: {
      "Laser Type": "Picosecond Nd:YAG Laser",
        mainImage: "/images/machines/remi-centrifuge.svg",
      "Energy": "100–5000 mJ (Adjustable)",
      "Cooling System": "Water + Air Cooling",
      "Pulse Width": "4 ns",
      "Output Power": "3000 W",
      "Laser Rod": "8 mm diameter",
      "Lamp": "Imported Heraeus (Germany)",
      "Spot Size": "2–10 mm",
      "Frequency": "1–10 Hz",
      "Screen": "10.4 inch touch screen",
      "Power Supply": "AC 220V / 110V, 50Hz / 60Hz"
    },
    applications: [
      "Tattoo removal (all colors)",
      "Pigmentation treatment",
      "Age spots and freckles",
      "Melasma treatment",
      "Skin rejuvenation",
      "Nevus of Ota",
      "Carbon peel treatment"
    ],
    features: [
      "Advanced Q-switch technology for precise energy delivery",
      "Dual wavelength system for versatile treatments",
      "German-imported lamp for consistent performance",
      "Real 8mm laser rod for optimal beam quality",
      "Adjustable parameters for customized treatments",
      "Built-in cooling system for patient comfort",
      "User-friendly touch screen interface"
    ],
    
  },
  {
    id: 2,
    name: "GENELUX-3",
    title: "Q-switched Nd:YAG Laser System",
    tagline: "Advanced Skin Rejuvenation",
    description: "GENELUX-3 combines cutting-edge laser technology with an intuitive design for gentle yet effective skin treatments. With its patented handpiece and long service life, this system is perfect for practices seeking reliable, professional-grade results.",
    mainImage: "/images/machines/2.png",
    resultImages: ["/images/machines/9.png"],
    hasResults: true,
    resultsHeading: "Before & After Results",
    keyPoints: [
      "Gentle skin rejuvenation process",
      "No consumable accessories needed",
      "Intuitive operating interface",
      "Patented handpiece design",
      "3 million shots service life"
    ],
    specifications: {
      "Wavelengths": "1064nm / 532nm",
      "Energy (1064nm)": "50–1000 mJ",
      "Energy (532nm)": "50–500 mJ",
      "Frequency": "1–10 Hz",
      "Weight": "22 kg",
      "Pulse Width": "6 ns",
      "Spot Size": "2–8 mm",
      "Cooling": "Air cooling",
      "Screen": "8 inch LCD touch screen",
      "Service Life": "3 million shots",
      "Power": "1000W"
    },
    applications: [
      "Pigmented lesions removal",
      "Tattoo removal",
      "Skin toning and brightening",
      "Carbon laser facial",
      "Melasma treatment",
      "Age spots removal"
    ],
    features: [
      "Patented handpiece for superior comfort",
      "No consumable parts reduces operational costs",
      "Long 3 million shot service life",
      "Intuitive interface for easy operation",
      "Dual wavelength capability",
      "Compact and lightweight design",
      "Professional-grade results"
    ]
  },
  {
    id: 3,
    name: "DIODE HAIR REMOVAL",
    title: "Advanced Diode + Picosecond System",
    tagline: "Permanent Hair Removal Solution",
    description: "Experience the ultimate in hair removal technology with our advanced 4-wavelength diode laser system. Suitable for all skin types and effective on all hair colors, this powerful system delivers permanent results with maximum patient comfort.",
    mainImage: "/images/machines/3.png",
    resultImages: ["/images/machines/10.png", "/images/machines/11.png"],
    hasResults: true,
    resultsHeading: "Hair Removal Results",
    keyPoints: [
      "Works on all skin types (I–VI)",
      "Four wavelengths technology",
      "Permanent hair removal",
      "Advanced cooling system",
      "Energy Fluence: 0–120 J/cm²"
    ],
    specifications: {
      "Technology": "Diode Laser + Nd:YAG",
      "Wavelengths": "755nm / 808nm / 940nm / 1064nm",
      "Laser Power": "1200W / 1600W",
      "Energy Fluence": "0–120 J/cm²",
      "Spot Size": "12×12 mm, 12×20 mm, 12×30 mm",
      "Frequency": "1–10 Hz",
      "Cooling": "Sapphire contact cooling (-10°C to 5°C)",
      "Screen": "10.4 inch touch screen",
      "Applications": "Hair removal, Skin rejuvenation",
      "Power Supply": "AC 220V±10%, 50Hz / AC 110V±10%, 60Hz"
    },
    applications: [
      "Permanent hair removal (all body areas)",
      "Suitable for all skin types (Fitzpatrick I-VI)",
      "Facial hair removal",
      "Body hair removal",
      "Ingrown hair treatment",
      "Skin rejuvenation"
    ],
    features: [
      "Four wavelengths for maximum effectiveness",
      "High power output (1200W/1600W)",
      "Advanced sapphire cooling for comfort",
      "Large spot sizes for fast treatment",
      "Safe for all skin types",
      "Adjustable parameters",
      "Fast treatment speed",
      "Excellent patient satisfaction"
    ]
  },
  {
    id: 4,
    name: "MEDI LIFT HIFU",
    title: "High-Intensity Focused Ultrasound",
    tagline: "Non-Surgical Facial Lifting",
    description: "Achieve remarkable lifting and tightening results without surgery using our advanced HIFU technology. The MEDI LIFT HIFU system combines macro and micro-focused ultrasound with RF technology for comprehensive facial rejuvenation.",
    mainImage: "/images/machines/4.png",
    resultImages: ["/images/machines/12.png", "/images/machines/13.png"],
    hasResults: true,
    resultsHeading: "Part Images",
    keyPoints: [
      "Painless, non-invasive treatment",
      "Multi-layer skin penetration",
      "RF Cryo Focus Technology",
      "Lifting & tightening effects",
      "Enhanced skin elasticity"
    ],
    specifications: {
      "Technology": "MMFU (Macro & Micro Focused Ultrasound)",
      "Energy Type": "Focused Ultrasound + Radio Frequency",
      "Treatment Mode": "Macro Focus + Micro Focus",
      "Cartridges": "1.5mm, 3.0mm, 4.5mm, 6mm, 9mm, 13mm",
      "Energy": "0.1–2.0 J (Adjustable)",
      "Shots per Cartridge": "10,000–20,000",
      "Screen": "15 inch touch screen",
      "Benefits": "Lifting, tightening, contouring",
      "Treatment Areas": "Face, neck, body"
    },
    applications: [
      "Face lifting and tightening",
      "Neck lifting",
      "Wrinkle reduction",
      "Double chin reduction",
      "Skin tightening",
      "Body contouring",
      "Jawline definition",
      "Eye area tightening"
    ],
    features: [
      "Macro and Micro focused ultrasound technology",
      "Multiple cartridge depths for customized treatments",
      "RF Cryo technology for enhanced results",
      "Non-invasive with no downtime",
      "Painless treatment",
      "Long-lasting results",
      "Safe and effective",
      "Visible results in 3-6 months"
    ]
  },
  {
    id: 5,
    name: "ULTRAFRAX CO2 FRACTIONAL",
    title: "Professional Fractional CO2 Laser",
    tagline: "Advanced Skin Resurfacing",
    description: "Transform skin texture and appearance with our professional fractional CO2 laser system. Featuring precise control and multiple working modes, ULTRAFRAX delivers exceptional results for skin resurfacing, scar treatment, and wrinkle reduction.",
    mainImage: "/images/machines/5.png",
    resultImages: ["/images/machines/14.png", "/images/machines/15.png"],
    hasResults: true,
    resultsHeading: "Skin Resurfacing Results",
    keyPoints: [
      "Wavelength: 10600 nm",
      "Max 60W Laser Power",
      "Multiple working modes",
      "Adjustable spot diameter",
      "20 × 20 mm scanning mode"
    ],
    specifications: {
      "Wavelength": "10600 nm",
      "Laser Power": "Max 60W",
      "Pulse Duration": "0.1 – 10 ms",
      "Spot Diameter": "100 – 2000 μm",
      "Scanning Mode": "20 × 20 mm",
      "Energy": "5–100 mJ",
      "Pulse Energy": "Up to 300 mJ",
      "Treatment Modes": "Fractional, Surgical, Vaginal",
      "Screen": "10.4 inch touch screen",
      "Cooling": "Air cooling system",
      "Articulated Arm": "7-joint articulated arm"
    },
    applications: [
      "Skin resurfacing",
      "Acne scar treatment",
      "Wrinkle reduction",
      "Skin tightening",
      "Stretch mark treatment",
      "Age spot removal",
      "Surgical applications",
      "Vaginal rejuvenation",
      "Keloid treatment"
    ],
    features: [
      "High power 60W CO2 laser",
      "Precise fractional technology",
      "Multiple treatment modes",
      "Adjustable parameters",
      "7-joint articulated arm for easy positioning",
      "Advanced scanning technology",
      "Safe and effective",
      "Professional results"
    ]
  },
  {
    id: 6,
    name: "ULTRAFRAX PRO CO2",
    title: "Advanced Cryolipolysis System",
    tagline: "Body Contouring & Fat Freezing",
    description: "Revolutionize body contouring with our advanced cryolipolysis system that combines fat freezing technology with hydrafacial treatment. Featuring 8 specialized handles and precise temperature control, achieve remarkable body sculpting results.",
    mainImage: "/images/machines/16.png",
    resultImages: ["/images/machines/17.png", "/images/machines/18.png"],
    hasResults: true,
    resultsHeading: "Body Contouring Results",
    keyPoints: [
      "8 specialized handles",
      "Temperature Range: -10°C to 45°C",
      "Cryolipolysis + Hydrafacial",
      "Fat freezing technology",
      "Deep cleansing & hydration"
    ],
    specifications: {
      "Technology": "Cryolipolysis + Hydrafacial",
      "Handles": "8 different specialized handles",
      "Temperature": "-10°C to 45°C",
      "Treatment Time": "35–60 minutes per area",
      "Vacuum Pressure": "0–100 kPa",
      "Screen": "10.4 inch touch screen",
      "Cooling": "Advanced cooling system",
      "Applications": "Fat freezing, body contouring",
      "Power": "500W",
      "Handle Types": "Large, medium, small, double chin, arms"
    },
    applications: [
      "Fat reduction",
      "Body contouring and sculpting",
      "Double chin reduction",
      "Love handles treatment",
      "Abdomen fat reduction",
      "Thigh sculpting",
      "Arm fat reduction",
      "Hydrafacial treatment",
      "Post-liposuction contouring"
    ],
    features: [
      "8 specialized handles for different body areas",
      "Precise temperature control",
      "Combines cryolipolysis with hydrafacial",
      "Non-invasive fat reduction",
      "No downtime required",
      "Comfortable treatment",
      "Long-lasting results",
      "Safe and FDA-cleared technology"
    ]
  },
  {
    id: 7,
    name: "OXYGEN JET PEEL PDT LED",
    title: "Light Hydrafacial Machine",
    tagline: "O₂ PDT Hydrafacial Treatment",
    description: "Experience the next generation of skincare with our Oxygen Jet Peel PDT LED Light Hydrafacial Machine. This comprehensive system combines multiple advanced technologies for deep cleansing, exfoliation, hydration boost, and skin rejuvenation. Featuring 9 specialized treatment heads and customizable protocols for various skin concerns.",
    mainImage: "/images/machines/32.png",
    resultImages: ["/images/machines/32.1.png", "/images/machines/32.2.png"],
    hasResults: true,
    resultsHeading: "Part Images",
    keyPoints: [
      "9 specialized treatment heads",
      "Deep cleansing & exfoliation",
      "Hydration boost with serums",
      "PDT LED light therapy",
      "Non-invasive & painless"
    ],
    specifications: {
      "Technology": "Oxygen Jet Peel + PDT LED + Hydrafacial",
      "Treatment Heads": "9 different specialized heads",
      "Functions": "Micro bubble, V face, face impact, nano atomizing, oxygen injection, ice soothing, ion eye lifting, plasma, skin detection",
      "Treatment Time": "45–60 minutes per session",
      "Screen": "Touch screen display",
      "Accessories": "Nasal oxygen mask, oxygen mask, high pressure water oxygen",
      "Applications": "Deep cleansing, hydration, rejuvenation",
      "Treatment Type": "Non-invasive",
      "Suitable For": "All skin types"
    },
    applications: [
      "Deep cleansing and exfoliation",
      "Hydration boost and nutrient delivery",
      "Fine lines and wrinkles reduction",
      "Blackhead and whitehead removal",
      "Pore refinement",
      "Skin brightening and rejuvenation",
      "Acne treatment and scar reduction",
      "Uneven skin tone correction",
      "Anti-aging treatments"
    ],
    features: [
      "Micro bubble cleaning for deep pore cleansing",
      "V face ion wheel for facial contouring",
      "Face impact for skin stimulation",
      "Nano atomizing spray gun for hydration",
      "Oxygen injection for nutrient delivery",
      "Ice soothing for calming treatment",
      "Ion eye lifting pen for eye area",
      "Plasma technology for rejuvenation",
      "Skin detection head for analysis",
      "Non-invasive and painless treatment",
      "Customizable for various skin concerns",
      "Immediate visible results with glowing skin",
      "Gentle yet effective treatment",
      "Supports other advanced skincare procedures"
    ]
  },
  {
    id: 8,
    name: "ALLICE BUBBLE",
    title: "Hydra Facial Machine",
    tagline: "Advanced Hydradermabrasion System",
    description: "Transform your skincare routine with the ALLICE BUBBLE Hydra Facial Machine. This advanced system combines oxygen bubble technology, vibration atomization, and multiple treatment probes for comprehensive facial care. Featuring precise temperature control and multiple probe options for deep cleansing, hydration, and skin rejuvenation.",
    mainImage: "/images/machines/6.png",
    
    hasResults: true,
    resultsHeading: "Part Images",
    keyPoints: [
      "11 specialized probes (3 soft + 8 hard)",
      "Oxygen bubble deep cleansing",
      "Temperature control: 0-6C to 36-46C",
      "HR Frequency: 0.2-0.5 Mhz",
      "10.4 inch HD touch screen"
    ],
    specifications: {
      "Technology": "Hydradermabrasion + Oxygen Bubble",
      "Voltage": "100-240V 50HZ 60HZ",
      "Power": "100W",
      "HR Frequency": "0.2-0.5 Mhz",
      "Temperature Range": "Cold 0-6C, Hot 36-46C",
      "Ultrasound": "1.1 MHz",
      "Probe Count": "3 soft heads & 8 hard heads",
      "Display": "10.4 inches, Resolution 1024X600",
      "Clean Water Mill": "Positive pressure 4-5Kg, Negative pressure 96Kpa",
      "Flow Rate": "≤60L",
      "Treatment Time": "45-60 minutes per session",
      "Solution Bottles": "4 bottles included",
      "Treatment Type": "Non-invasive",
      "Suitable For": "All skin types"
    },
    applications: [
      "Deep layer cleansing",
      "Whitening and moisturizing",
      "Deep cleansing and exfoliation",
      "Instrument piping cleaning",
      "Blackhead and pore cleaning",
      "Skin hydration and nourishment",
      "Acne treatment",
      "Fine lines reduction",
      "Skin brightening and rejuvenation"
    ],
    features: [
      "Oxygen bubble technology for deep pore cleansing",
      "Vibration atomization for enhanced absorption",
      "Spray function for hydration delivery",
      "Diamond dermabrasion for exfoliation",
      "Cold & hot therapy for skin tightening",
      "Tripolar HR for skin firming",
      "Bipolar HR for targeted treatment",
      "Multiple probe options for different treatments",
      "Precise temperature control system",
      "High-definition touch screen display",
      "4-layer cleaning solution system",
      "Positive and negative pressure control",
      "Safe and painless treatment",
      "Immediate visible results",
      "Professional-grade hydrafacial system"
    ]
  },
  {
    id: 9,
    name: "2 IN 1 ADVANCED ANTI-AGING RF TECHNOLOGY MNRF",
    title: "Microneedling RF & Cryo Stamp System",
    tagline: "Advanced Anti-Aging RF Technology",
    description: "Experience revolutionary anti-aging treatment with our 2-in-1 MNRF system. Microneedling Radiofrequency (MNRF) is a minimally invasive technique to rejuvenate skin with less downtime. It uses arrays of tiny microneedles with radiofrequency waves to heat the deeper layers of your skin to stimulate collagen production, improving the appearance of acne scars and fine lines. The entire procedure causes minimal damage to the upper layers of skin and involves minimal downtime, making it safe for all skin types.",
    mainImage: "/images/machines/33.png",
    
    hasResults: true,
    resultsHeading: "Treatment Results",
    keyPoints: [
      "RF microneedle with vacuum suction",
      "Cryo Stamp cooling technology",
      "2MHz bipolar RF frequency",
      "Multiple cartridge options (10, 25, 64, Nano)",
      "Minimal downtime, safe for all skin types"
    ],
    specifications: {
      "Technology": "Microneedling RF + Cryo Stamp",
      "RF Frequency": "2MHz, bipolar",
      "RF Power": "10-200W",
      "Treatment Duration": "0.1-0.6s",
      "Suction Level": "2 level",
      "Cartridges/Pins": "10, 25, 64, Nano",
      "Display": "8.4 inch touch screen",
      "Needle Thickness": "0.3mm",
      "Voltage": "AC 110V/220V, 50Hz/60Hz",
      "Needle Depth": "0.2-3.5mm",
      "Cooling Temperature": "1-5°C",
      "Size": "118 X 47 X 67cm",
      "Weight": "45kg",
      "Treatment Type": "Minimally invasive",
      "Suitable For": "All skin types"
    },
    applications: [
      "Skin rejuvenation and anti-aging",
      "Acne scar treatment and reduction",
      "Fine lines and wrinkles improvement",
      "Collagen stimulation and production",
      "Skin tightening and firming",
      "Skin texture improvement",
      "Pore size reduction",
      "Stretch marks treatment",
      "Hyperpigmentation and uneven skin tone",
      "Surgical scar improvement"
    ],
    features: [
      "RF microneedle with vacuum suction technology",
      "Cryo Stamp for instant cooling and soothing",
      "2MHz bipolar radiofrequency for deep heating",
      "Multiple cartridge options: 10, 25, 64, and Nano pins",
      "Adjustable needle depth from 0.2mm to 3.5mm",
      "Precise treatment duration control (0.1-0.6 seconds)",
      "Variable RF power ranging from 10W to 200W",
      "Large 8.4 inch touch screen display",
      "2-level vacuum suction control",
      "Advanced cooling system (1-5°C)",
      "0.3mm ultra-fine needle thickness",
      "Minimally invasive procedure",
      "Minimal damage to upper skin layers",
      "Minimal downtime required",
      "Safe and effective for all skin types",
      "Stimulates deep dermal collagen production",
      "Combines heat therapy with cryotherapy",
      "Professional-grade anti-aging system"
    ]
  },
  {
    id: 10,
    name: "PRO MNRF",
    title: "Professional Microneedling RF System",
    tagline: "Advanced RF Microneedling Technology",
    description: "Achieve remarkable skin transformation with the PRO MNRF Professional Microneedling RF System. This advanced device combines radiofrequency energy with microneedling technology to deliver powerful anti-aging and skin rejuvenation results. With dual frequency options (2MHz/8MHz), 400W power output, and multiple treatment modes, this professional-grade system addresses a wide range of skin concerns from wrinkles to acne scars.",
    mainImage: "/images/machines/34.png",
    resultImages: ["/images/machines/34.1.png", "/images/machines/34.2.png"],
    hasResults: true,
    resultsHeading: "Treatment Results",
    keyPoints: [
      "Dual RF Frequency: 2MHz / 8MHz",
      "Powerful 400W output",
      "10 treatment modes",
      "6 needle adapter tip options",
      "Professional-grade system"
    ],
    specifications: {
      "Technology": "Microneedling RF",
      "RF Frequency": "2MHz / 8MHz (Dual frequency)",
      "Power": "400W",
      "Treatment Modes": "1-10",
      "Pulse Time": "Adjustable",
      "Microneedle Treatment Head": "250-500ms",
      "Non-Insulated Treatment Head": "1000-3000ms",
      "Needle Adapter Heads": "10-PIN TIP, 25-PIN TIP, 36-PIN TIP, 49-PIN TIP, 64-PIN TIP, 81-PIN TIP",
      "Coagulation Parameter": "0.1-4mm",
      "Network": "220V",
      "Weight": "22 kg",
      "Dimensions": "40*34*118 cm",
      "Treatment Type": "Minimally invasive",
      "Suitable For": "All skin types"
    },
    applications: [
      "Skin tightening and lifting",
      "Wrinkles around the mouth reduction",
      "Overall skin rejuvenation",
      "Active inflamed acne treatment",
      "Large pores reduction",
      "Atrophic acne scars improvement",
      "Skin discoloration and pigmentation correction",
      "Increased sweating (hyperhidrosis) treatment",
      "Fading stretch marks",
      "Fine lines and wrinkles reduction",
      "Skin texture improvement"
    ],
    features: [
      "Dual RF frequency (2MHz / 8MHz) for versatile treatments",
      "Powerful 400W output for effective results",
      "10 adjustable treatment modes for customization",
      "6 different needle adapter heads (10, 25, 36, 49, 64, 81 pins)",
      "Microneedle treatment head with 250-500ms pulse time",
      "Non-insulated treatment head with 1000-3000ms pulse time",
      "Adjustable coagulation parameter (0.1-4mm depth)",
      "Professional touch screen interface",
      "Compact and mobile design with wheels",
      "Portable tabletop unit also available",
      "Precise depth control for targeted treatment",
      "Safe for all skin types",
      "Minimally invasive procedure",
      "Effective for skin tightening",
      "Treats active acne and acne scars",
      "Reduces large pores and pigmentation",
      "Addresses hyperhidrosis (excessive sweating)",
      "Fades stretch marks effectively",
      "Professional-grade medical device"
    ]
  },
  {
  "id": 11,
  "name": "360 CRYO SLIMMING MACHINE",
  "title": "Advanced Cryolipolysis Fat Freezing System",
  "tagline": "360° Cooling & Heating for Body Contouring",
  "description": "The 360 Cryo Slimming Machine is an advanced cryolipolysis system designed for non-invasive fat reduction and body contouring. It uses 360-degree cooling and heating technology with silicone replacement heads for maximum comfort. The system supports up to 8 different cryo handles for treating multiple body areas efficiently, delivering visible fat loss after just one session.",
  "mainImage": "/images/machines/35.png",
  "resultImages": [
    "/images/machines/35.1.png",
    
  ],
  "hasResults": true,
  "resultsHeading": "Before & After Results",
  "keyPoints": [
    "360° full-range cooling and heating",
    "Freezing fat cells at -10°C to -45°C",
    "8 silicone cryo handles for different body areas",
    "Comfortable and safe treatment",
    "Non-invasive with visible results"
  ],
  "specifications": {
    "Technology": "Cryolipolysis Cryotherapy V+",
    "Working Power": "1500W",
    "Negative Pressure": "0–80K",
    "Cryo Temperature": "-10°C to -45°C",
    "Cooling System": "Water + Semiconductor Condenser",
    "Screen": "10.4 inch touch screen",
    "Handle Size": "4.5 inch",
    "Cryo Handles": "8 pieces",
    "Handle Material": "Silicone",
    "Machine Size": "62 × 46 × 170 cm",
    "Machine Weight": "56 kg",
    "Packing Size": "115 × 65 × 58 cm"
  },
  "applications": [
    "Fat reduction",
    "Body slimming",
    "Skin tightening",
    "Body contouring",
    "Relaxation and pain relief"
  ],
  "features": [
    "Soft silicone replacement heads for comfort",
    "360° cryolipolysis cooling and heating",
    "Group cycle modes for multi-area treatment",
    "Deep therapy penetration up to 12cm",
    "2cm–3cm fat reduction after one treatment",
    "Safe and non-invasive procedure",
    "Suitable for multiple body parts",
    "High-efficiency fat freezing technology",
    "Stable temperature control system",
    "Professional-grade aesthetic equipment"
  ]
},
{
  "id": 12,
  "name": "650NM HAIR REGROWTH PANEL",
  "title": "Advanced Laser Hair Regrowth Therapy Machine",
  "tagline": "650nm Low-Level Laser Therapy for Hair Restoration",
  "description": "The 650nm Hair Regrowth Panel is a professional laser therapy system designed to stimulate hair follicles, improve scalp circulation, and promote natural hair regrowth. Using low-level laser diode technology, it enhances cellular metabolism, increases ATP activity, reduces excess oil secretion, and helps control inflammation for healthier, stronger hair growth.",
  "mainImage": "/images/machines/36.png",
  "resultImages": [
    
  ],
  "hasResults": true,
  "resultsHeading": "Hair Growth Results",
  "keyPoints": [
    "650nm laser wavelength for optimal follicle stimulation",
    "Enhances nutrient absorption in hair roots",
    "Accelerates blood circulation and metabolism",
    "Controls oil secretion and reduces hair loss",
    "Safe for long-term and repeated use"
  ],
  "specifications": {
    "Technology": "Laser Diode",
    "Wavelength": "650nm",
    "Working Mode": "Continuous and Pulse",
    "Frequency": "30Hz, 50Hz, 70Hz, 90Hz",
    "Laser Power": "Max 10mW",
    "Treatment Time": "1–60 minutes",
    "Cooling System": "Air Cooling",
    "Power Supply": "100–240VAC, 50/60Hz"
  },
  "applications": [
    "Hair regrowth stimulation",
    "Hair loss prevention",
    "Improved scalp blood circulation",
    "Sebaceous gland regulation",
    "Dandruff and follicle health improvement",
    "Post-treatment hair recovery"
  ],
  "features": [
    "Low-level laser therapy (LLLT)",
    "Promotes ATP production in hair follicle cells",
    "Enhances oxygen and nutrient delivery",
    "Kills pathogenic bacteria in hair follicles",
    "Reduces excess oil secretion",
    "Improves hair follicle activity",
    "Non-invasive and painless treatment",
    "No chemicals or drugs required",
    "Safe for men and women",
    "Professional salon and clinic use"
  ]
},
{
  "id": 13,
  "name": "A5 PLUS AI INTELLIGENT IMAGER",
  "title": "Advanced AI Skin Analysis & Imaging System",
  "tagline": "Professional AI Facial Skin Detection Solution",
  "description": "The A5 Plus AI Intelligent Imager is a high-end facial skin analysis system developed with advanced spectral imaging and artificial intelligence technology. It objectively analyzes multiple facial skin problems with one-click photo capture and automatic report generation. Designed for clinics and beauty professionals, it supports cloud storage, data comparison, and long-term skin tracking.",
  "mainImage": "/images/machines/37.png",
  "resultImages": [
    
  ],
  "hasResults": true,
  "resultsHeading": "AI Skin Analysis Results",
  "keyPoints": [
    "AI intelligent facial diagnosis",
    "Eight-spectrum imaging technology",
    "17 detailed skin testing indicators",
    "Supports different skin tones analysis",
    "Fast and accurate skin reports"
  ],
  "specifications": {
    "Model": "ZML-A5 Plus",
    "Pixel": "36 Million (Industrial Grade)",
    "Spectrum": "White light, positive polarized light, negative polarized light, UV light, red pigment map, brown map",
    "Light Shielding Mode": "Semi-open",
    "Materials": "ABS Industrial Grade",
    "Power Supply": "AC 100–260V, 50/60Hz",
    "Memory": "Dual-channel LPDDR4 4G",
    "Hard Drive": "MMC 51, 32G"
  },
  "testingIndicators": [
    "Hydration",
    "Pores",
    "Blackheads",
    "Sebum",
    "Skin Barrier",
    "Acne",
    "Wrinkles",
    "Mixed Spots",
    "Superficial Pigment",
    "Porphyrin",
    "Collagen",
    "Fluorescent Agent",
    "Deep Pigment",
    "Brown Pigment",
    "Heat Map of Sensitivity",
    "Heat Map of Pigment",
    "Red Map of Sensitivity"
  ],
  "features": [
    "Eight spectral imaging modes",
    "AI automatic skin recognition",
    "Seventeen professional testing indicators",
    "Cloud data storage and management",
    "Customer file management system",
    "Background system management",
    "Adjusting skin test results",
    "Three comparative analysis modes",
    "One-click photography and report output",
    "Supports yellow, white, dark, and brown skin tones",
    "Professional clinic and salon use"
  ],
  "applications": [
    "Facial skin analysis",
    "Pre-treatment skin diagnosis",
    "Post-treatment comparison",
    "Personalized skincare planning",
    "Clinic and beauty salon consultations"
  ]
},
{
  "id": 14,
  "name": "A3 AI SKIN ANALYSER",
  "title": "Professional AI Facial Skin Analysis Machine",
  "tagline": "8-Spectrum Intelligent Skin Detection System",
  "description": "The A3 AI Skin Analyser is an advanced facial skin detection system using artificial intelligence and 8-spectrum imaging technology. It provides accurate facial positioning, zone detection, and multi-layer skin analysis to identify various skin problems. Designed for clinics and beauty professionals, it offers instant report generation, secure data management, and precise skin assessment for personalized treatment planning.",
  "mainImage": "/images/machines/38.png",
  "resultImages": [
    
  ],
  "hasResults": true,
  "resultsHeading": "AI Skin Analysis Results",
  "keyPoints": [
    "AI facial positioning and precise zone detection",
    "8-spectrum imaging for comprehensive analysis",
    "Deep and superficial skin layer detection",
    "Safe imaging with 40 protective filters",
    "Fast, accurate, and reliable skin reports"
  ],
  "specifications": {
    "Model": "A3 AI Intelligent Imager",
    "Control": "Touch screen",
    "Screen Features": "90-degree foldable",
    "WiFi": "Dual-band 2.4G & 5G",
    "HDMI": "1 port",
    "Screen Ratio": "16:9",
    "Screen Size": "15.6 inches",
    "Screen Resolution": "1920 × 1080",
    "Camera Pixel": "36 million (industrial grade)",
    "Spectrum": "RGB white light, positive polarized light, negative polarized light, UV light, red light, brown light, mixed light",
    "Materials": "Industrial grade ABS plastic",
    "Power Supply": "AC 100–260V, 50/60Hz",
    "Processor": "Rockchip RK3399 dual Cortex-A72",
    "System": "Android 8.1",
    "Accessories": "Handheld skin analyzer, power cord"
  },
  "features": [
    "AI automatic facial recognition and alignment",
    "8-spectrum imaging technology",
    "Accurate detection of skin problems",
    "Analysis of deep and surface skin layers",
    "40 eye-protection optical filters",
    "Built-in WiFi for instant data transfer",
    "Supports report printing and sharing",
    "Three types of analysis with detailed results",
    "Customer database management system",
    "High accuracy and repeatability"
  ],
  "applications": [
    "Facial skin diagnosis",
    "Pre-treatment consultation",
    "Post-treatment comparison",
    "Personalized skincare planning",
    "Clinic and beauty salon use"
  ]
},

{
  "id": 15,
  "name": "EMSLIM NEO RF",
  "title": "Advanced EMSLIM NEO RF Body Sculpting System",
  "tagline": "Non-Invasive Muscle Toning & Fat Reduction",
  "description": "The EMSLIM NEO RF is a powerful non-invasive body sculpting machine that combines high-intensity electromagnetic stimulation (EMS) with radiofrequency (RF) technology. It effectively builds and strengthens muscles, improves body tone, reduces fat, and tightens skin. A single 30-minute treatment delivers the equivalent of more than 20,000 muscle contractions, making it an ideal solution for fast and visible body shaping.",
  "mainImage": "/images/machines/39.png",
  "resultImages": [
   
  ],
  "hasResults": true,
  "resultsHeading": "Body Sculpting Results",
  "keyPoints": [
    "High-intensity EMS muscle stimulation",
    "Radiofrequency heating for tightening",
    "30-minute treatment equals 20,000+ contractions",
    "Non-invasive and painless procedure",
    "Effective for men and women"
  ],
  "specifications": {
    "Input Power": "110–220V, 50/60Hz",
    "Output Power": "2800W",
    "EMS Frequency": "5–100Hz",
    "EMS Intensity": "0–100",
    "RF Frequency": "27.12MHz",
    "RF Intensity": "0–100",
    "Cooling Method": "Air Cooled",
    "Screen Size": "18 inch"
  },
  "applications": [
    "Muscle building",
    "Body toning",
    "Fat reduction",
    "Abdomen sculpting",
    "Buttock lifting",
    "Thigh shaping",
    "Arm toning",
    "Postpartum body recovery"
  ],
  "features": [
    "EMS technology for deep muscle contractions",
    "RF energy for skin tightening",
    "World’s first non-invasive buttock lifting procedure",
    "30-minute high-efficiency treatment",
    "Treats abdomen, buttocks, thighs, and arms",
    "No downtime or recovery",
    "Safe and comfortable treatment",
    "Large 18-inch touch screen",
    "Professional clinic and salon equipment",
    "Stable and powerful energy output"
  ]
},
{
  "id": 16,
  "name": "EM SCULPT",
  "title": "Advanced EM Sculpt Body Contouring System",
  "tagline": "Muscle Growth & Fat Reduction via Supramaximal Contractions",
  "description": "EM Sculpt is a non-invasive body sculpting technology that uses high-intensity electromagnetic stimulation to induce supramaximal muscle contractions. These powerful contractions increase energy demand, triggering epinephrine release and initiating fat cell lipolysis. Triglycerides are broken down into free fatty acids, leading to fat cell dysfunction and apoptosis. The destroyed fat cells are naturally eliminated while muscle tone and strength are significantly improved.",
  "mainImage": "/images/machines/40.png",
  
  "hasResults": true,
  "resultsHeading": "Before & After Results",
  "keyPoints": [
    "Induces supramaximal muscle contractions",
    "Triggers fat cell lipolysis through epinephrine release",
    "Breaks down triglycerides into free fatty acids",
    "Causes fat cell apoptosis and natural elimination",
    "Simultaneous muscle strengthening and toning"
  ],
  "specifications": {
    "Technology": "High-Intensity Electromagnetic (HIFEM)",
    "Treatment Type": "Non-invasive body sculpting",
    "Primary Effect": "Muscle building and fat reduction",
    "Target Areas": "Abdomen, buttocks, thighs, arms"
  },
  "applications": [
    "Muscle toning and strengthening",
    "Fat reduction",
    "Body contouring",
    "Abdominal sculpting",
    "Buttock lifting",
    "Thigh and arm shaping"
  ],
  "features": [
    "High-intensity electromagnetic stimulation",
    "Non-invasive and painless treatment",
    "No downtime or recovery period",
    "Clinically proven fat cell apoptosis",
    "Enhances muscle definition",
    "Safe for men and women",
    "Visible results after multiple sessions"
  ]
},
{
  "id": 17,
  "name": "RADIO FREQUENCY CAUTERY",
  "title": "Professional RF Cautery Surgical System",
  "tagline": "Precision Cutting with Minimal Tissue Damage",
  "description": "Radio Frequency Cautery is an advanced dermatological surgical system designed for precise cutting and coagulation with minimal heat generation. Operating at 2.7MHz, it enables pressure-less cutting, reduced operating time, minimal bleeding, and minimal pain. The system ensures pin-point accuracy with no lateral heat spread, resulting in least tissue damage and faster healing.",
  "mainImage": "/images/machines/41.png",
  "resultImages": [
    "/images/machines/41.1.png",
    "/images/machines/41.2.png"
  ],
  "hasResults": true,
  "resultsHeading": "Procedure Results",
  "keyPoints": [
    "Pressure-less cutting with pin-point accuracy",
    "No lateral heat spread",
    "Minimal blood loss and pain",
    "Reduced tissue damage and faster healing",
    "Shock-proof and safe to operate"
  ],
  "specifications": {
    "Operating Modes": "Cut, Cut-Coagulation, Coagulation",
    "Operating Frequency": "2.7 MHz",
    "Power Settings": "10 steps",
    "Voltage": "AC 220–230V, 50Hz",
    "Power": "100W",
    "Dimensions": "223 × 223 × 85 mm"
  },
  "applications": [
    "Intradermal nevus removal",
    "Skin tags and moles",
    "Corns and seborrheic warts",
    "Keloid treatment",
    "Electrolysis procedures",
    "Xanthelasma removal",
    "Soft fibromas",
    "Skin connective tissue nevus"
  ],
  "features": [
    "Reduced operating time",
    "Pressure-less cutting",
    "No lateral heat damage",
    "Minimal bleeding and pain",
    "Minimal heat with no charring",
    "Pin-point cutting capability",
    "Shock-proof design",
    "Ideal for dermatology and cosmetic clinics"
  ]
},
{
  "id": 18,
  "name": "9-IN-1 ADVANCED MEDI-FACIAL DEVICE",
  "title": "High-Tech Medi-Facial System",
  "tagline": "Complete Skin Rejuvenation & Hydration",
  "description": "Experience advanced skincare with our 9-IN-1 Medi-Facial Device. This system combines CO2 bubble cleaning, bipolar RF, hydra dermabrasion, ultrasonic therapy, and facial contouring for deep cleansing, hydration, lifting, and skin rejuvenation. Comes with 9 handpieces and a metal trolley for professional use.",
  "mainImage": "/images/machines/42.png",
  "resultImages": ["/images/machines/42.1.png", "/images/machines/42.2.png"],
 
  "hasResults": true,
  "resultsHeading": "Before & After",
  "keyPoints": [
    "9 specialized handpieces for multiple skin treatments",
    "CO2 bubble cleaning for deep pore cleansing",
    "Hydra dermabrasion and oxygen infusion",
    "Ultrasonic facial and eye therapy",
    "Non-invasive, painless, and effective"
  ],
  "specifications": {
    "Screen Size": "10\"",
    "Handpiece Number": "9 Pcs",
    "Dimension": "114 x 48 x 58 cm",
    "Weight": "35 Kg",
    "Technology": "Bipolar RF + Hydra Dermabrasion + Ultrasonic + CO2 Bubble Cleaning",
    "Treatment Type": "Non-invasive",
    "Accessories": "Metal trolley, 9 handpieces",
    "Functions": "Cleansing, hydration, lifting, firming, eye care, oxygen infusion",
    "Applications": "Deep cleansing, hydration boost, skin tightening, fine lines reduction, eye rejuvenation"
  },
  "applications": [
    "Deep pore cleansing",
    "Hydration and nutrient infusion",
    "Skin lifting and firming",
    "Fine lines and wrinkles reduction",
    "Eye area rejuvenation",
    "Skin texture and tone improvement",
    "Acne and blemish care",
    "Maximized serum absorption"
  ],
  "features": [
    "CO2 bubble cleaning for exfoliation and pore cleansing",
    "Bipolar RF energy stimulates collagen and elastin",
    "Hydra dermabrasion for hydration and impurity removal",
    "Ultrasonic face and eye therapy for product absorption",
    "Facial shaper for contouring and toning muscles",
    "Non-invasive and painless treatment",
    "Metal trolley for easy mobility",
    "Customizable handpieces for specific skin concerns",
    "Combines exfoliation, oxygen infusion, and nutrient delivery",
    "Professional-grade high-tech mechanical pump"
  ]
},
{
  "id": 19,
  "name": "PICO SECOND Q-SWITCH ND:YAG LASER",
  "title": "Advanced Tattoo & Pigmentation Removal System",
  "tagline": "Effective Skin Rejuvenation & Pigment Removal",
  "description": "This Nd:Yag laser system provides safe and effective treatment for tattoo removal, pigmented lesions, acne scars, wrinkles, and skin rejuvenation. Using high-energy light, the laser selectively targets melanin or tattoo pigments, breaking them down while minimizing side effects. Advanced double-lamp, double-rod technology ensures stable and powerful output.",
  "mainImage": "/images/machines/43.png",
  "resultImages": ["/images/machines/43.1.png", "/images/machines/43.2.png", "/images/machines/43.3.png"],
  "hasResults": true,
  "resultsHeading": "Before & After",
  "keyPoints": [
    "Double lamp, double rod for stable light output",
    "7-articular arm for precise targeting",
    "Spot size adjustable from 2–10 mm",
    "Shock-absorbing design for stability",
    "Intelligent system with safety alarms",
    "Effective for all tattoo colors and pigment lesions",
    "Skin whitening and wrinkle reduction"
  ],
  "specifications": {
    "Laser Type": "Nd:Yag laser",
    "Wavelength": "532nm, 755nm, 1064nm",
    "Pulse Width": "5 ns",
    "Frequency": "1–10 Hz adjustable",
    "Energy": "100–2000 mJ",
    "Spot Size": "2–10 mm adjustable",
    "Voltage": "110/220V, 50/60Hz",
    "Power": "2000W",
    "Dimensions": "118 x 52 x 109 cm",
    "Weight": "Not specified"
  },
  "applications": [
    "All color tattoo removal (including eyeline & lip line)",
    "Pigment lesions: nevus of Ota, blue nevus, black nevus",
    "Coffee spots, senile plaques, freckles, sunburn spots, chloasma",
    "Skin whitening",
    "Wrinkle reduction"
  ],
  "features": [
    "Double-lamp, double-rod system for stable, high-energy output",
    "7-articular arm for precise and flexible treatment",
    "Adjustable spot size for targeted treatment areas",
    "Shock-absorbing design enhances stability during procedures",
    "Intelligent system with built-in safety alarms",
    "Effective on all tattoo colors and various pigment lesions",
    "Non-invasive skin rejuvenation and whitening",
    "Supports acne scar and wrinkle improvement"
  ]
},
{
  "id": 20,
  "name": "DIODE HAIR REMOVAL 1600W",
  "title": "Advanced Diode Laser Hair Removal System",
  "tagline": "Safe, Fast, and Painless Hair Removal",
  "description": "This high-power 1600 W Diode Laser Hair Removal system provides effective, precise, and safe hair removal for all skin types. Featuring multiple spot sizes, adjustable pulse widths, and advanced cooling, it ensures comfort while delivering optimal results. The 15.6” color touch display allows easy operation for professional clinics.",
  "mainImage": "/images/machines/44.png",
  "resultImages": ["/images/machines/34.1.png", "/images/machines/34.2.png"],
  "hasResults": true,
  "resultsHeading": "Before & After",
  "keyPoints": [
    "High-power 1600 W diode laser for fast treatments",
    "Multiple spot sizes for precision on all areas",
    "Adjustable pulse width (10ms–200ms) and frequency (1–10 Hz)",
    "Effective cooling system for comfort",
    "Non-invasive and suitable for all skin types",
    "Easy-to-use 15.6” color touch display"
  ],
  "specifications": {
    "Wavelength": "755nm, 808nm, 940nm, 1064nm",
    "Handle Power": "1600 W",
    "Spot Size": "Ф8mm, 5x5mm, 10x10mm, 12x20mm, 20x40mm",
    "Pulse Width": "10ms ~ 200ms",
    "Frequency": "1 Hz ~ 10 Hz",
    "Fluence": "0 ~ 120 J/cm²",
    "Laser Intensity": "5% ~ 100%",
    "Contact Temperature": "-5℃ ~ 5℃",
    "Cooling System": "Air + Water + TEC / Semiconductor + Sapphire",
    "Screen": "15.6” color touch display",
    "Voltage": "AC 220V/50Hz, 110V/60Hz"
  },
  "applications": [
    "Permanent hair reduction for all skin types",
    "Facial and body hair removal",
    "Sensitive areas hair treatment",
    "Fast treatment for large areas",
    "Painless and safe hair removal procedures"
  ],
  "features": [
    "High-power 1600 W diode laser for fast results",
    "Multiple spot sizes for targeted treatment",
    "Adjustable pulse width and frequency for safety",
    "Advanced cooling system to reduce pain and irritation",
    "Non-invasive and suitable for all skin types",
    "15.6” color touch display for easy operation",
    "Durable and reliable laser handle",
    "Supports continuous professional use in clinics"
  ]
},
{
  "id": 21,
  "name": "3-WAVELENGTH DIODE & PICO SECOND LASER",
  "title": "Multi-Function Hair & Skin Treatment Laser System",
  "tagline": "Hair Removal, Skin Brightening, Pigment Correction & Rejuvenation",
  "description": "This advanced Dio-Pico laser system combines a 3-wavelength diode laser and a pico second laser for comprehensive hair removal, pigmentation correction, tattoo removal, skin rejuvenation, and whitening. Safe for all skin types (I–VI), it features high-power handles, adjustable pulse widths, and precise aiming for professional clinical use.",
  "mainImage": "/images/machines/45.png",
  
  "resultsHeading": "Before & After",
  "keyPoints": [
    "Diode laser (755, 808, 1064 nm) for safe and effective hair removal",
    "Pico second laser (532, 755, 1064, 1320 nm) for pigment removal and skin rejuvenation",
    "Adjustable pulse width (10–300 ms) and frequency (1–10 Hz)",
    "High power handles: Diode 600 W, Pico 1600 W",
    "Red aiming light for precision targeting",
    "Safe for all skin types, minimal downtime",
    "Large water tank and effective cooling for continuous operation"
  ],
  "specifications": {
    "Model": "Dio Pic",
    "Environment Moisture": "<70%",
    "Input VAC": "220 VAC, 50–60 Hz",
    "System Cooling Method": "Water + Fan",
    "Cooling Temperature": "-5°C ~ 20°C",
    "Interface Language": "English",
    "Screen": "10.4in color display",
    "Water Tank Volume": "10L",
    "Diode Laser Handle Wavelength": "808, 755, 1064 nm",
    "Diode Handle Power": "600 W",
    "Machine Power": "1600 W",
    "Laser Cooling Liquid": "Pure Water",
    "Working Temperature": "15–28°C",
    "Pico Laser Handle Wavelength": "755, 532, 1064 nm",
    "Pico Handle Power": "1600 W",
    "Frequency": "1–10 Hz",
    "Number of Shots": "20 million",
    "Spot Size": "12x20 mm",
    "Pulse Width": "10–300 ms"
  },
  "applications": [
    "Hair removal for all skin types and hair colors",
    "Tattoo removal for various pigment colors",
    "Pigment lesion treatment: freckles, sunspots, chloasma",
    "Skin brightening and whitening",
    "Pore tightening and texture improvement",
    "Skin rejuvenation and wrinkle reduction"
  ],
  "features": [
    "3-wavelength diode laser for safe and effective hair removal",
    "Pico second laser for pigmentation, tattoo removal, and skin rejuvenation",
    "Adjustable pulse width and frequency for safety and precision",
    "Red aiming light for precise treatment",
    "High-power handles for efficient clinical use",
    "Water + fan cooling system ensures device longevity",
    "Large 10L water tank for continuous operation",
    "Safe for all skin types (I–VI), minimal downtime",
    "Professional-grade display and interface for easy operation",
    "Multiple treatment options in a single device"
  ]
},

{
  "id": 22,
  "name": "NEW DOUBLO HIFU",
  "title": "Macro & Micro HIFU Ultrasound Lifting System",
  "tagline": "Non-Invasive Skin Lifting, Tightening & Body Contouring",
  "description": "New Doublo HIFU is an advanced Macro & Micro focused ultrasound system designed for non-invasive face lifting, skin tightening, wrinkle reduction, and body contouring. Using MFU, SD, and RF technologies with multiple cartridge depths, it delivers precise energy to different skin layers for collagen stimulation, fascia tightening, and fat compaction with minimal downtime.",
  "mainImage": "/images/machines/46.png",
  "resultImages": ["/images/machines/48.1.png", "/images/machines/48.2.png", "/images/machines/48.3.png"],
  "hasResults": true,
  "resultsHeading": "Before & After",
  
  "keyPoints": [
    "Macro & Micro HIFU technology for face and body treatments",
    "Multiple cartridges for different skin depths (1.5mm–9.0mm)",
    "MFU, SD, and RF treatment modes",
    "Non-invasive skin lifting and tightening",
    "Stimulates collagen and tightens fascia",
    "Minimal downtime and safe clinical operation"
  ],
  "specifications": {
    "Model": "New Doublo HIFU",
    "FL Cartridge Parameters": "1.5mm (7MHz, 0.1J–0.5J), 2.0mm (7MHz, 0.1J–1.0J), 3.0mm (7MHz, 0.1J–1.0J), 4.5mm (4MHz, 0.1J–1.5J), 6.0mm (2MHz, 0.1J–3.0J), 9.0mm (2MHz, 0.1J–3.0J)",
    "SD Cartridge Parameters": "1.5mm (7MHz, 0.1J–0.5J), 3.0mm (7MHz, 0.1J–2.0J), 4.5mm (4MHz, 0.1J–1.5J), 9.0mm (2MHz, 0.1J–3.0J)",
    "RF Frequency": "2MHz",
    "RF Level": "Level 1–10",
    "Spacing": "1.0–5.0mm",
    "Scope": "5.0–25mm (1.0mm step)",
    "Handpieces": "Quattro handpieces",
    "Display": "12.1in Wide LCD",
    "System Features": "TIS (Treatment Information System), RMS (Remote Maintenance System)",
    "Operation Mode": "Auto mode and Manual mode",
    "Handpiece Sensor": "Automatic handpiece sensor",
    "User Interface": "Easy & intuitive GUI",
    "Size": "700(W) × 605(L) × 1315(H) mm",
    "Weight": "43.5 kg"
  },
  "applications": [
    "Face lifting and skin tightening",
    "Wrinkle reduction and anti-aging",
    "Jawline and cheek lifting",
    "Double chin and fat compaction",
    "Body contouring",
    "Skin firming and rejuvenation"
  ],
  "features": [
    "Macro & Micro HIFU technology for multi-layer treatment",
    "Multiple cartridge depths for precise targeting",
    "MFU, SD, and RF combined system",
    "Collagen stimulation and fascia tightening",
    "Non-invasive treatment with minimal downtime",
    "Advanced smart system with treatment tracking",
    "Stable performance with professional clinical design",
    "Easy-to-use wide LCD interface",
    "Designed for face and body treatments",
    "Professional medical-aesthetic grade device"
  ]
},
{
  "id": 23,
  "name": "8 IN 1 + 9 HYDRA FACIAL MACHINE",
  "title": "Advanced Hydra Facial Machine",
  "tagline": "One Machine, Multiple Skin Care Functions",
  "description": "8 in 1 + 9 Hydra Facial Machine is a multifunctional skincare system combining hydro dermabrasion, photon light, oxygen therapy, microcurrent, RF, ultrasonic, and plasma technologies. Designed for deep cleansing, skin rejuvenation, pore tightening, lifting, and firming with non-invasive and painless treatment suitable for all skin types.",
  "mainImage": "/images/machines/47.png",

  "resultsHeading": "Treatment Results",
  "keyPoints": [
    "8+9 multifunctional hydra facial skincare system",
    "Deep cleansing and blackhead removal",
    "Skin tightening, lifting, and firming",
    "Non-invasive, painless, and bloodless treatment",
    "4 solution bottles (A, B, C, D) for continuous operation",
    "Suitable for all skin types"
  ],
  "specifications": {
    "Vacuum": ">100Kpa",
    "Technology": "Hydro dermabrasion, photon light",
    "Max Output": "250VA",
    "Treatment Handle": "8 (standard) + 9 (optional)",
    "Screen": "10.4in Touch LCD",
    "Voltage": "100–240VAC, 50Hz/60Hz"
  },
  "applications": [
    "Deep skin cleansing",
    "Blackhead and acne removal",
    "Skin rejuvenation",
    "Shrink pores",
    "Skin tightening and firming",
    "Moisturizing and skin care"
  ],
  "features": [
    "Multiple skincare functions in one machine",
    "Hydro dermabrasion and oxygen revitalizing bubble",
    "Ultrasonic, RF, microcurrent, and plasma treatments",
    "Diamond microdermabrasion and electric microneedle support",
    "Color light masks for skin improvement",
    "User-friendly interface with large touch screen",
    "Non-invasive and painless therapy",
    "Professional aesthetic clinic design"
  ]
},
{
  "id": 24,
  "name": "EMSLIM NEO RF",
  "title": "HI-EMT Muscle Building & RF Fat Reduction System",
  "tagline": "Muscle Sculpting, Fat Reduction & Body Toning",
  "description": "EMSLIM NEO RF (B610B+RF) is a non-invasive body sculpting system combining HI-EMT (High Intensity Electromagnetic Technology) and RF heating. It induces extreme muscle contractions to build muscle density and volume while accelerating fat decomposition and tightening skin through controlled RF heating.",
  "mainImage": "/images/48.png",

  "resultsHeading": "Treatment Results",
  "keyPoints": [
    "HI-EMT technology for intense muscle contraction",
    "RF heating for fat reduction and skin tightening",
    "30-minute session equals 20,000 sit-ups or squats",
    "Builds muscle and reduces fat simultaneously",
    "Non-invasive, painless, and bloodless treatment",
    "Suitable for abdomen, buttocks, thighs, arms, calves, and flanks"
  ],
  "specifications": {
    "Model": "B610B+RF",
    "Input Power": "110–220V, 50Hz–60Hz",
    "Output Power": "2800W",
    "EMS Frequency": "5–100Hz",
    "EMS Intensity": "0–100",
    "RF Frequency": "27.12MHz",
    "RF Intensity": "0–100",
    "Cooling Method": "Air Cooled",
    "Screen Size": "18 inches",
    "Packing Size": "57 × 75 × 122 cm",
    "Gross Weight": "101 kg"
  },
  "applications": [
    "Muscle building and strengthening",
    "Abdomen toning and fat reduction",
    "Buttock lifting and shaping",
    "Thigh and arm muscle sculpting",
    "Body contouring",
    "Skin tightening with RF heating"
  ],
  "features": [
    "HI-EMT focused electromagnetic muscle stimulation",
    "RF-assisted fat reduction and skin firming",
    "Dual treatment for muscle growth and fat apoptosis",
    "Independent A/B/C/D handle operation",
    "Adjustable EMS and RF intensity levels",
    "Large 18-inch touch screen interface",
    "Air-cooled system for stable performance",
    "Non-invasive alternative to surgical body sculpting",
    "Suitable for men and women",
    "Professional body contouring device"
  ]
},
{
  id: 25,
  name: "808M DIODE LASER HAIR REMOVAL",
  title: "Advanced 808nm Diode Laser Hair Removal Machine",
  tagline: "Permanent Hair Removal Solution - Fast & Painless",
  description: "The 808NM Diode Laser Hair Removal Machine is a state-of-the-art system designed for fast, safe, and permanent hair removal on all skin types. Featuring advanced cooling technology and a high-resolution display, this professional-grade system delivers exceptional results with maximum patient comfort.",
  mainImage: "/images/machines/49.png",
  "resultImages": ["/images/machines/50.png", "/images/machines/51.png", "/images/machines/52.png"],
  "hasResults": true,
  "resultsHeading": "Before & After",
  keyPoints: [
    "Four wavelengths (755nm / 808nm / 940nm / 1064nm)",
    "Fast and permanent hair removal",
    "Suitable for all hair types and skin types",
    "Pain-free treatment with sapphire cooling system",
    "15.6 inch color touch LCD screen",
    "Multiple spot sizes for precise treatment",
    "24-hour continuous operation capability",
    "Skin rejuvenation benefits"
  ],
  specifications: {
    "Laser Type": "808nm Diode Laser",
    "Laser Power Range": "600W/800W/1000W/1200W/1600W",
    "Display": "15.6 inch color touch LCD screen",
    "Spot Size": "12x20 mm², 12x35 mm², 12x12 mm², 8.3 mm",
    "Pulse Width": "10-400ms adjustable",
    "Energy": "10-120 J/cm²",
    "Frequency": "1-20Hz (continuous mode)",
    "Cooling System": "Water + air + semiconductor + Sapphire TEC cooling",
    "Temperature of Probe": "-16°C",
    "Handpiece Cooling": "Sapphire TEC cooling + water cooling + real-time monitoring",
    "Water System Cooling": "USA high power condenser module + fan cooling",
    "Water System Protection": "Italian water pump with flow, level, and temperature monitoring",
    "Continuous Operation": "24 hours",
    "Peak Power": "3000W",
    "Shots": "100 million shots",
    "Voltage": "AC 220V±22V, 50/60Hz, 10A"
  },
  applications: [
    "Permanent hair removal (all body areas)",
    "Suitable for all skin types and hair colors",
    "Facial hair removal",
    "Body hair removal",
    "Fine and coarse hair removal",
    "Ingrown hair treatment",
    "Skin rejuvenation and anti-aging"
  ],
  features: [
    "Professional-grade 808nm diode laser technology",
    "Multiple power options (600W to 1600W)",
    "Advanced sapphire + TEC cooling for maximum comfort",
    "Multiple spot sizes for versatile treatments",
    "15.6-inch color touch display for easy operation",
    "Fast treatment speed with high frequency",
    "Water + air + semiconductor cooling system",
    "100 million shots lifespan",
    "24-hour continuous operation capability",
    "Safe for all skin types including dark skin",
    "Adjustable parameters for customized treatments",
    "Real-time monitoring and safety features",
    "Italian water pump for reliability",
    "USA-grade cooling condenser module"
  ]
},
{
  "id": 26,
  "name": "10D HIFU",
  "title": "MMFU Macro & Micro Focused Ultrasound System",
  "tagline": "Non-surgical Facial Lift, Tightening & Body Contouring",
  "description": "10D HIFU is a medical-grade Macro & Micro Focused Ultrasound (MMFU) system featuring a multifunctional probe with dual-engine high-energy transducers. It delivers layered, precise ultrasound energy (micro & macro) to target dermis, SMAS/fascia, and subcutaneous fat for lifting, tightening, and body contouring with minimal downtime.",
  "mainImage": "/images/machines/53.png",
  "hasResults": true,
  "resultsHeading": "Clinical Applications & Outcomes",
  "keyPoints": [
    "MMFU Dual Engine: Macro & Micro focused ultrasound in one probe",
    "High-energy transducers: 4 & 7 MHz for micro coagulation, 2 MHz for macro energy",
    "Multiple cartridge depths for layered treatments (0.25mm special, 0.5mm, 1.5mm, 2.0mm, 3.0mm, 4.5mm, 6.0mm, 9.0mm, 13.0mm)",
    "Cartridges optimized for facial micro-treatment and body macro treatment",
    "Original patented eye cartridge (5.5 MHz) for periorbital and deep lines",
    "Triple / Quartet layer facial treatment capability for superior lifting",
    "Fast treatment with high shot counts (e.g., 20,000 face / 30,000 body selectable modes)",
    "Foldable 15 inch touch screen, multifunctional probe and handles",
    "KFDA & CE international safety certifications"
  ],
  "specifications": {
    "Technology": "MMFU (Macro & Micro Focused Ultrasound)",
    "Transducer Frequencies": "2 MHz (macro) / 4 MHz & 7 MHz (micro) / 5.5 MHz eye cartridge",
    "Cartridge Depths": "0.25mm, 0.5mm, 1.5mm, 2.0mm, 3.0mm, 4.5mm, 6.0mm, 9.0mm, 13.0mm",
    "Shots (Face/Body)": "20000 (face mode) / 30000 (body mode)",
    "Screen": "Foldable 15 inch touch screen",
    "Operation Mode": "Auto / Manual",
    "Spacing": "Adjustable",
    "Power": "High peak power dual-engine",
    "Handpieces": "Multifunctional probe with replaceable cartridges",
    "Size": "Standard trolley unit",
    "Warranty": "Manufacturer warranty (check supplier)"
  },
  "applications": [
    "Non-surgical face lifting and tightening",
    "Neck lifting and jawline contouring",
    "Eye area tightening and deep line reduction",
    "Body contouring and localized fat reduction",
    "Skin tightening and wrinkle reduction",
    "SMAS layer lifting and collagen remodeling"
  ],
  "features": [
    "Dual-engine MMFU technology for macro & micro targeting",
    "High-precision cartridges for accurate focal delivery",
    "Specialized eye cartridges and triple-layer facial protocols",
    "Layered cartridges for deeper body treatment (6mm/9mm/13mm)",
    "Fast shot modes and energy control for patient comfort",
    "Non-invasive, safe, and effective clinical results",
    "Foldable 15\" touch display for ergonomic operation",
    "KFDA & CE international certification"
  ],
  "category": "energy-based"
},
{
  "id": 27,
  "name": "HYDRA STAR",
  "title": "10-in-1 Advanced Multi-Function Beauty Device",
  "tagline": "Professional Deep Cleansing, Hydration & Skin Rejuvenation System",
  "description": "Hydra Star is a revolutionary 10-in-1 multi-function beauty device combining aqua peel, oxygen jet, EMS face therapy, RF, ultrasound, cold-heat technology, micro lift, cleansing shovel, and skin analyzer. Performed via device rather than by hand, it delivers deeper penetration and longer-lasting results. It improves skin health, addresses individual concerns, and creates a glow like no other in just 3 steps and 30 minutes.",
  "mainImage": "/images/machines/54.png",
  "hasResults": true,
  "resultsHeading": "Life-Changing Results",
  "keyPoints": [
    "10-in-1 multi-function platform for all skin care needs",
    "3-step treatment protocol: Cleanse+Peel → Extract+Hydrate → Fuse+Protect",
    "Complete in 30 minutes with instant and long-lasting results",
    "Deep cleansing with aqua peel and oxygen jet technology",
    "EMS nanocrystals for 40%+ enhanced product absorption",
    "RF, ultrasound, and cold-heat for skin tightening and firming",
    "Integrated skin analyzer for personalized treatment planning"
  ],
  "specifications": {
    "Voltage": "100-120V/60Hz or 200-240V/50Hz",
    "Display": "10.4 inches color LCD",
    "Power": "500W",
    "RF Frequency": "0.2-0.5 MHz",
    "Temperature Control": "Heat: 36-46°C, Cool: 0-6°C",
    "Ultrasound": "1 MHz",
    "Aqua Peel Probes": "Soft: 3 pcs, Hard: 8 pcs",
    "Aqua Peel Vacuum": "Intensity: 4-5kg, Pressure: 96kPa",
    "Water Flow Rate": "≤50L",
    "Cleansing Shovel Frequency": "26-30 MHz",
    "EMS Nano Mesotherapy": "Frequency: 200Hz, Current: 50-800μA, Size: 4×4mm×250μm",
    "Skin Analyzer": "28 Million HD Mega Pixels",
    "Aqua Peel Solutions": "A: Cleaning, B: Whitening & Moisturizing, C: Deep Layer Cleaning, D: Pipe Cleaning"
  },
  "applications": [
    "Deep cleansing and pore refinement",
    "Fine lines and wrinkles reduction",
    "Skin elasticity and firmness improvement",
    "Even skin tone and vibrancy enhancement",
    "Acne and congested skin treatment",
    "Brown spots and pigmentation correction",
    "Enlarged pore reduction",
    "Sagging skin tightening",
    "Dry skin hydration and repair",
    "Anti-aging and facial contouring"
  ],
  "features": [
    "Aqua Peel: Gentle exfoliation and deep cleanse with pore opening",
    "Oxygen Jet (A & B type): High-pressure oxygen injection with small particles for deep penetration",
    "EMS Face: Nanocrystal technology opening absorption channels for 40%+ increased product penetration",
    "Cold-Heat: Temperature control below 0°C for redness removal, anti-sensitivity, and skin firming",
    "Micro Lift: Alternating positive/negative EMS microcurrent for facial contouring and lifting",
    "Oxygen: Oxygen supply environment activation for enhanced cellular function and product absorption",
    "Ultrasound: 1-3 million vibrations per minute for >90% essence absorption into basal layer",
    "RF Technology: 6 million vibrations per second for skin-tightening and wrinkle improvement",
    "Cleansing Shovel: High-frequency vibrations to soften stratum corneum and deeply clean skin",
    "Skin Analyzer: 28MP HD imaging for comprehensive skin analysis and personalized solutions",
    "Three-step protocol: Cleanse+Peel → Extract+Hydrate → Fuse+Protect",
    "Versatile languages and user-friendly intelligent operating system",
    "Non-invasive, painless treatment with device-based delivery",
    "Professional and personal use capability",
    "Long-lasting, visible results in 30 minutes per session"
  ],
  "benefits": [
    "Uncovers new layer of skin with gentle exfoliation",
    "Removes debris from pores with painless suction",
    "Nourishes with intense moisturizers for skin hydration",
    "Saturates skin surface with antioxidants and peptides",
    "Achieves instant and long-lasting visible results",
    "Addresses fine lines, elasticity, tone, texture, and pores",
    "Controls breakouts and improves skin clarity",
    "Creates a youthful, glowing complexion"
  ],
  "category": "hydrafacial"
},


{
  id: 28,
  name: "T3 AI Intelligent Scalp Analyzer",
  title: "AI Intelligent Scalp Analyzer",
  tagline: "Four-Spectrum Imaging + AI Analysis for Scalp Health",
  description: "T3 AI Intelligent Scalp Analyzer combines ISP image processing, four-spectrum light sensing, and AI algorithms to convert microscopic scalp conditions into visual data and diagnostic reports. It evaluates 13 scalp indicators across five scalp regions to provide objective, professional analysis for salons, clinics, and home use.",
  mainImage: "/images/machines/55.png",
  resultImages: [],
  hasResults: true,
  resultsHeading: "Scalp Analysis Results",
  keyPoints: [
    "Four-spectral imaging (White, Positive Polarized, Negative Polarized, UV 365nm)",
    "AI-driven analysis with 13 diagnostic indicators",
    "50x and 200x magnification with HD optics",
    "Five-part detection: forehead, left, right, top, occiput",
    "Cloud data storage, custom reports and watermarking"
  ],
  specifications: {
    "Spectra": "White / Positive Polarized / Negative Polarized / UV (365nm)",
    "Magnification": "50x, 200x",
    "Imaging": "ISP image processing + AI algorithms",
    "Report Modes": "Single | Comprehensive | Custom",
    "Connectivity": "App integration and cloud storage",
    "Applicable Scenarios": "Beauty salon, Hair salon, Hair transplant clinic, Home use"
  },
  testingIndicators: [
    "Moisture",
    "Scalp sebum",
    "Blocked hair follicles",
    "Dandruff",
    "Sensitivity",
    "Red area map",
    "Gray hair",
    "Heat Map of Pigment",
    "Hair density",
    "Hair thickness",
    "Hair follicle health",
    "Heat Map of Sensitivity",
    "Scalp condition"
  ],
  applications: [
    "Scalp condition diagnosis",
    "Pre-treatment assessment and post-treatment monitoring",
    "Hair loss risk evaluation",
    "Customized treatment and product recommendations",
    "Clinic and salon consultations; home self-check"
  ],
  features: [
    "Four-spectrum shooting with retake/confirm workflow",
    "Three testing modes: Comprehensive, Real-time preview, Free mode",
    "Moisture detection handheld probe",
    "13 objective detection indicators with heatmaps and overlays",
    "Comparison mode across timepoints and regions",
    "Report export, watermarking, and cloud archive",
    "Backend management and customer file system"
  ],
  category: "scalp-analyser"
}

  ,
  {
    id: 29,
    name: "AUTOMATIC DERMA BED",
    title: "Automatic Electric Derma Treatment Bed",
    tagline: "Adjustable Electric Treatment Bed for Clinics & Salons",
    description: "Automatic Derma Bed designed for professional clinics and salons. Built with thickened steel plate construction and electric adjustments for backrest and legs to ensure patient comfort and efficient treatment workflows.",
    mainImage: "/images/machines/56.png",
    resultImages: [],
    hasResults: false,
    keyPoints: [
      "Electric adjustable backrest and leg sections",
      "Thickened steel plate construction",
      "Comfortable padded surface with removable covers",
      "Handrail support and safety features",
      "Compact footprint for clinic spaces"
    ],
    specifications: {
      "Product Size": "1080 × 870 × 1060 mm",
      "Product Material": "Thickened steel plate",
      "Handrail Size": "40 mm",
      "Height Size": "46.5 mm",
      "Adjustable Backrest": "0–70°",
      "Legs Adjustment": "0–70°",
      "Power": "AC 220V / 50Hz"
    },
    applications: [
      "Medical aesthetic treatments",
      "Facial and dermal procedures",
      "Hair and scalp treatments",
      "General clinic use",
      "Salon treatment bed"
    ],
    features: [
      "Electric lift and tilt for effortless positioning",
      "Durable powder-coated steel frame",
      "Easy-to-clean upholstery",
      "Safety handrails and cable management",
      "Stable base with adjustable feet"
    ],
    category: "body-toning"
  },
    
    {
      id: 30,
      name: "REMI CENTRIFUGE",
      title: "Remi Clinical Centrifuge",
      tagline: "Compact centrifuge for PRP and sample processing",
      description: "Compact Remi centrifuge suitable for clinical sample processing, PRP preparation, and small-scale lab procedures in aesthetic clinics.",
      mainImage: "/images/machines/57.png",
      resultImages: [],
      hasResults: false,
      keyPoints: [
        "Compact footprint for clinic benches",
        "Adjustable speed settings",
        "Safety lid interlock",
        "Suitable for PRP and sample separation",
        "Low maintenance"
      ],
      specifications: {
        "Speed Range": "0–4000 RPM",
        "Rotor Type": "Fixed-angle rotor",
        "Capacity": "Up to 6 × 10ml tubes",
        "Power": "AC 220V / 50Hz",
        "Dimensions": "Approx 20 × 20 × 18 cm"
      },
      applications: [
        "PRP preparation",
        "Clinical sample separation",
        "Small lab centrifugation tasks"
      ],
      features: [
        "Easy-to-use speed dial",
        "Safety interlock lid",
        "Compact and durable design",
        "Non-slip feet"
      ],
      category: "device"
    }
];


